import { useEffect, useState } from "react";
import { ModalWraper } from "../../../../../components/modal/wraper";
import { PppoeUserService } from "../../../../../services/PppoeUserService";

export const PppoeUpdateStatus = ({
    refresh,
    openModal,
    setOpenModal,
    status,
    id,
}) => {
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        status: "",
    });

    useEffect(() => {
        if (status) {
            setFormData({ status });
        }
    }, [status, openModal]);

    const closeModal = () => {
        setOpenModal(false);
        if (status) {
            setFormData({ status });
        }
        setLoading(false);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.status) return;

        setLoading(true);
        try {
            await PppoeUserService.statusUpdate({
                id: id,
                data: { status: formData.status },
            });
            refresh?.();
            closeModal();
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    if (!openModal) return null;

    return (
        <ModalWraper
            isOpen={openModal}
            setIsOpen={setOpenModal}
            title="Update Status Pelanggan"
        >
            <form onSubmit={handleSubmit} className="space-y-5">
                <RadioPppoeStatus
                    label="Pilih Status"
                    value={formData.status}
                    onChange={(value) =>
                        setFormData((prev) => ({ ...prev, status: value }))
                    }
                />

                <div className="flex gap-3">
                    <button
                        type="button"
                        onClick={closeModal}
                        className="flex-1 py-3 rounded-xl border border-slate-700 text-slate-300"
                    >
                        Batal
                    </button>
                    <button
                        type="submit"
                        disabled={loading || !formData.status}
                        className="flex-1 py-3 rounded-xl bg-cyan-600 hover:bg-cyan-500 disabled:bg-slate-700 disabled:opacity-50 text-white font-semibold flex items-center justify-center gap-2"
                    >
                        {loading ? "Menyimpan..." : "Simpan"}
                    </button>
                </div>
            </form>
        </ModalWraper>
    );
};

export const RadioPppoeStatus = ({
    label = "Status",
    value,
    onChange,
  }) => {
    const options = [
      {
        value: "aktif",
        label: "Aktif",
        color: "text-emerald-400",
      },
      {
        value: "nonaktif",
        label: "Nonaktif",
        color: "text-red-400",
      },
      {
        value: "suspend",
        label: "Suspend",
        color: "text-amber-400",
      },
    ];
  
    return (
      <div className="w-full">
        <label className="font-medium text-white uppercase mb-3 block">
          {label}
        </label>
  
        <div className="flex flex-col gap-3">
          {options.map((item) => (
            <label
              key={item.value}
              className="flex items-center gap-3 cursor-pointer rounded-lg border border-white/10 px-4 py-3 hover:bg-white/5"
            >
              <input
                type="radio"
                name="pppoe_status"
                value={item.value}
                checked={value === item.value}
                onChange={() => onChange(item.value)}
                className="w-4 h-4"
              />
  
              <span className={`font-medium ${item.color}`}>
                {item.label}
              </span>
            </label>
          ))}
        </div>
      </div>
    );
  };